import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  price: '17€',
  title: 'Kit Inclusività BES/DSA — Inclusione 360°',
  desc: 'Mappe concettuali semplificate per ogni epoca letteraria, schede facilitate ad alta leggibilità e verifiche compensative già pronte. Tutto conforme alla Legge 170/2010. Non lasciare indietro nessuno studente senza moltiplicare il tuo lavoro.'
}, {
  num: '02',
  price: '24€',
  title: "AI per Docenti — L'Intelligenza Artificiale in Classe",
  desc: "Prompt già pronti per ChatGPT per creare verifiche in 30 secondi, rubriche di valutazione automatiche e guida completa per rilevare il plagio da IA nei temi degli studenti. Il docente del futuro usa l'IA. Inizia oggi."
}, {
  num: '03',
  price: '22€',
  title: 'Educazione Civica e Debate',
  desc: "20 temi di dibattito strutturati per coprire le 33 ore obbligatorie MIM, con la letteratura italiana come strumento di cittadinanza attiva. Schede pronte per ogni attività. Assolvi l'obbligo ministeriale trasformandolo in didattica viva."
}, {
  num: '04',
  price: '24€',
  title: 'Agenda della Correzione Rapida',
  desc: 'Sistema professionale di simboli e abbreviazioni per correggere temi nella metà del tempo. Include feedback pre-scritto per gli studenti e modelli di valutazione rapida per ogni tipologia testuale. Smetti di passare le serate a correggere.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-36" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-38">
          <div className="bg-brand-orange/20 p-4 rounded-full mb-4" data-id="element-39">
            <GiftIcon className="w-10 h-10 text-brand-orange" data-id="element-40" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream leading-tight" data-id="element-41">
            4 Bonus Esclusivi nel tuo Kit,
            <br data-id="element-42" />
            <span className="text-brand-gold" data-id="element-43">senza costo extra</span>
          </h2>
          <p className="text-gray-400 text-sm mt-3 max-w-2xl" data-id="element-44">
            Elementi aggiuntivi del valore di 87€ in regalo con l'acquisto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-45">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-6 sm:p-7 rounded-2xl shadow-[0_0_20px_rgba(249,115,22,0.1)]" data-id="element-46">
              <div className="flex items-center justify-between gap-3 mb-3" data-id="element-47">
                <span className="text-2xl font-black text-white/30" data-id="element-48">
                  {bonus.num}
                </span>
                <div className="bg-green-500/20 border border-green-500/40 text-green-400 text-[11px] font-black px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-49">
                  {bonus.price} — GRATIS
                </div>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-brand-gold mb-3 leading-tight" data-id="element-50">
                {bonus.title}
              </h3>
              <p className="text-gray-300 font-medium text-sm sm:text-base leading-relaxed" data-id="element-51">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center bg-brand-card border border-brand-gold/40 rounded-2xl p-5" data-id="element-52">
          <p className="text-sm text-gray-400 mb-1" data-id="element-53">Valore totale dei bonus</p>
          <p className="text-3xl font-black text-brand-gold" data-id="element-54">
            87€{' '}
            <span className="text-base text-brand-cream" data-id="element-55">INCLUSI GRATIS</span>
          </p>
        </div>
      </div>
    </section>;
}